import * as Yup from 'yup'

import i18n from '../../../i18n'
import {
  FILTER_TEMPLATE_NAME_FIELD,
  FILTER_TEMPLATE_NAME_FIELD_PUBLIC,
  FILTER_TEMPLATE_NAME_MAX_LENGTH,
} from '../Filter.constants'

export function createNewFilterGetValidationSchema() {
  return Yup.object({
    [FILTER_TEMPLATE_NAME_FIELD]: Yup.string()
      .required(() => true)
      .max(
        FILTER_TEMPLATE_NAME_MAX_LENGTH,
        i18n.t('Error.MaxLengthKey', {
          length: FILTER_TEMPLATE_NAME_MAX_LENGTH,
        })
      ),
  })
}

export function getPayload(values) {
  return {
    [FILTER_TEMPLATE_NAME_FIELD]: values[FILTER_TEMPLATE_NAME_FIELD],
    [FILTER_TEMPLATE_NAME_FIELD_PUBLIC]:
      values[FILTER_TEMPLATE_NAME_FIELD_PUBLIC],
  }
}
